import { ItCompleteSubscriptionsState } from '@pages/subscriptions-old/store/states/it-complete-subscriptions.state';
import { K365SubscriptionsState } from '@pages/subscriptions-old/store/states/k365-subscriptions.state';
import { K365FunctionsState } from '@pages/subscriptions-old/store/states/k365-functions.state';

export const subscriptionsStateOld = [ItCompleteSubscriptionsState, K365FunctionsState, K365SubscriptionsState];
